function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGototop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 0 14.109375 L 1.40625 15.5 L 10.011719 7.238281 L 10.929688 8.121094 L 10.925781 8.113281 L 18.574219 15.457031 L 20 14.085938 C 17.886719 12.058594 11.984375 6.394531 10.011719 4.5 C 8.546875 5.90625 9.976562 4.535156 0 14.109375 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGototop);
export default __webpack_public_path__ + "static/media/gototop.c20cf4e5ee9a9a8be88cfc64bece0432.svg";
export { ForwardRef as ReactComponent };